<template>
  <v-container fluid>
    <v-card>
      <v-card-title>ИИ карточки</v-card-title>

      <v-card-text>
        <v-form ref="form" class="mb-n1">
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <Time-Interval v-model="filters.period" />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Project-Selector v-model="filters.project" single />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <User-Selector v-model="filters.users" no-rules />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Campaign-Selector v-model="filters.campaigns" :project-ids="filters.project" no-rules :disabled.sync="disableCampaignSelector" />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Queue-Selector v-model="filters.queues" :project-ids="filters.project" no-rules />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <Ai-Text-Selector v-model="filters.texts" :project-ids="filters.project" />
            </v-col>

            <v-col cols="12" align="right">
              <v-btn
                color="info"
                class="mt-4 mr-1"
                :disabled="loading"
                :loading="loading"
                @click="loadReport({excel: true})"
              >Excel</v-btn>

              <v-btn
                class="mt-4"
                color="success"
                :disabled="loading"
                :loading="loading"
                @click="loadReport({excel: false, firstPage: true})"
              >Поиск</v-btn>

            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mt-5">
      <v-data-table
        :headers="report.headers"
        :items="report.items"
        :items-per-page="paginate.per_page"
        :loading="loading"
        single-expand
        :expanded.sync="expanded"
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        item-key="id"
        hide-default-footer
        @click:row="openRow"
      >
        <template #expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <h4 v-if="item.data.length" class="my-4">Карточка</h4>
            <v-simple-table
              v-if="item.data.length"
              class="mb-6"
              style="max-width: fit-content;"
              dense
            >
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="formItem in item.data"
                    :key="formItem.code + utils.randomString()"
                  >
                    <td>{{ formItem.title }}</td>
                    <td>{{ formItem.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <h4 v-if="item.data.length === 0">Нет данных...</h4>
          </td>
        </template>

        <template #top>
          <v-row v-if="paginate.last_page > 1">
            <v-col cols="1"></v-col>
            <v-col cols="4">
              <v-pagination
                v-model="paginate.current_page"
                :length="paginate.last_page"
                :total-visible="7"
                @input="loadReport({excel: false})"
              />
            </v-col>
          </v-row>
        </template>

        <template #[`item.operator`]="{ item }">
          [{{ item.sip }}] {{ item.agent }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :href="callUrl(item.uid)"
                target="_blank"
                v-on="on"
                v-bind="attrs"
              >
                <v-icon dense>mdi-dock-window</v-icon>
              </v-btn>
            </template>
            <span>Просмотреть звонок (в новой вкладке)</span>
          </v-tooltip>

        </template>

        <template #footer>
          <v-row v-if="paginate.last_page > 1">
            <v-col cols="1"></v-col>
            <v-col cols="4">
              <v-pagination
                v-model="paginate.current_page"
                :length="paginate.last_page"
                :total-visible="7"
                @input="loadReport({excel: false})"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import AiTextSelector from '~/components/partials/selectors/AiTextSelector.vue'
import CampaignSelector from '~/components/partials/selectors/CampaignSelector.vue'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue'
import QueueSelector from '~/components/partials/selectors/QueueSelector.vue'
import UserSelector from '~/components/partials/selectors/UserSelector.vue'
import { axios } from "~/plugins/axios"
import TimeInterval from './elements/TimeInterval.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AiCardAnalyses',

  components: {
    TimeInterval,
    ProjectSelector,
    UserSelector,
    CampaignSelector,
    AiTextSelector,
    QueueSelector,
  },

  data() {
    return {
      loading: false,
      filters: {
        period: {},
        project: [],
        users: [],
        campaigns: [],
        queues: [],
        texts: [],
      },
      disableCampaignSelector: true,
      report: {
        headers: [
          {text: 'Дата', value: 'date'},
          {text: 'Оператор', value: 'operator'},
          {text: 'Телефон', value: 'client_phone'},
          {text: 'Название промта', value: 'text'},
          {text: '', value: 'actions'},
        ],
        items: [],
      },
      expanded: [],
      paginate: {
        total: null,
        current_page: 1,
        last_page: null,
        per_page: 25
      }
    }
  },

  computed: {},

  methods: {
    ...mapActions({
      setError: 'shared/setError',
      setLoading: 'shared/setLoading',
    }),
    getPayload(excel = false) {
      const payload = {
        ...this.filters,
        excel,
        limit: this.paginate.per_page,
        page: this.paginate.current_page,
      }

      if (this.filters.period) {
        payload.period = [
          moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }
      if (this.filters.project) {
        payload.project = this.filters.project[0]
      }

      if (this.filters.queues.length === 0) delete payload.queues
      if (this.filters.users.length === 0) delete payload.users
      if (this.filters.campaigns.length === 0) delete payload.campaigns


      return payload
    },

    openRow(item, context) {
      context.expand(!context.isExpanded)
    },

    callUrl(uid) {
      return `${process.env.VUE_APP_API_DOMAIN}${this.$router.resolve({
        name: 'SpeechAnalysisCall',
        params: {uid}
      }).href}`
    },

    async loadReport(options = {excel: false, firstPage: false}) {
      if (!this.$refs.form.validate()) return
      this.loading = true
      this.setLoading(true)

      const {excel, firstPage} = options
      if (firstPage) this.paginate.current_page = 1

      const payload = this.getPayload(excel)
      let headers = {}
      if (excel === true) headers = {responseType: "blob"}

      try {
        const response = await axios.post('/api/reports/analysis-ai-cards', payload, headers)
        if (excel) {
          this.utils.downloadXlsx(response)
        } else {
          this.report.items = response.data.items
          this.paginate = response.data.paginate
        }
      } catch (error) {
        let payload = {message: error}
        if (error.response.data) payload = error.response.data
        this.setError(payload)
      } finally {
        this.loading = false
        this.setLoading(false)
      }
    },
  },

  mounted() {},
}
</script>

<style scoped></style>
